import configRepository from '../../repositories/ConfigRepository';

const tagManager = {

    install: function () {

        console.log('install tagmanager');

        function setScript() {
           
            if (configRepository.configLoaded) {
                if (configRepository.mouseflowProjectId && configRepository.mouseflowProjectId.length) {
                    (function () {
                        console.log('install mouseflow with projectId' + configRepository.mouseflowProjectId);
                        window._mfq = window._mfq || [];
                        var mf = document.createElement("script");
                        mf.type = "text/javascript"; mf.async = true;
                        mf.src = "//cdn.mouseflow.com/projects/" + configRepository.mouseflowProjectId + ".js";
                        document.getElementsByTagName("head")[0].appendChild(mf);
                    })();
                }                
            } else {
                window.setTimeout(setScript, 500);
            }
        }

        setScript();

    }
}

export { tagManager as default };


